export default __webpack_public_path__ + "static/media/Nympheas_et_saule_grand_porte_cle.3d43b571.png";